// extracted by mini-css-extract-plugin
export default {"control":"Abritre_control__zowhp","wrapper":"Abritre_wrapper__r4KdL","confirm":"Abritre_confirm__dOzlP","price":"Abritre_price__EQTOT"};